module.exports = __webpack_public_path__ + "static/capex-cdfbc0f9c4f0e063a896c9a59e087f51.png";